import i18n from '@/locales'
export default [
  {
    type: 'input',
    placeholder: i18n.t('Fota.firmwareName'),
    filed: 'name',
    default: ''
  }
]
